import { AxiosPromise } from 'axios'
import { AppApiResponseData } from '../types/api'
import http from './http'
import {
	ChecklistEditRequestData,
	ChecklistForPatientSelectedFieldsInfo,
} from '../types/checklist'

export function get(
	patientId: string
): AxiosPromise<AppApiResponseData<ChecklistForPatientSelectedFieldsInfo>> {
	return http({
		method: 'GET',
		url: `/p/patient/${patientId}/checklist`,
	})
}

export function create(
	patientId: string,
	data: ChecklistEditRequestData
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'POST',
		url: `/p/patient/${patientId}/checklist`,
		data,
	})
}

export function update(
	patientId: string,
	checklistId: string,
	data: ChecklistEditRequestData
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'PUT',
		url: `/p/patient/${patientId}/checklist/${checklistId}`,
		data,
	})
}
